import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AssessmentGroup } from '../../shared/models/assessment-group';
import { Assessment } from '../../shared/models/assessment';
import { AssessmentGroupService } from '../services/assessment-group.service';
import { AssessmentGroupDisplay } from '../../shared/models/assessment-group-display';
import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { AuthService } from 'app/login/services/auth.service';
import { Capability } from 'app/shared/models/capability';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'dac-assessment-group-list',
  templateUrl: './assessment-group-list.component.html',
  styleUrls: ['./assessment-group-list.component.css']
})
export class AssessmentGroupListComponent implements OnInit, OnDestroy {

  public NewGroupName:string;
  public hasLoadedTokens:boolean;

  @Output() selected = new EventEmitter<AssessmentGroup>();
  @Output() buy = new EventEmitter<AssessmentGroup>();

  private groups:AssessmentGroupDisplay[];

  private _userSubscription:ISubscription;
  private canShop:boolean;

  constructor(
    private assessmentGroupService:AssessmentGroupService
    ,private assessmentTokenService:AssessmentTokenService
    ,private authService:AuthService
  ) { 
    this.hasLoadedTokens = false;
    this.groups = [];
    this.canShop = false;

    this._userSubscription = this.authService.getLoginState().subscribe(loginState =>{
      if (loginState.user) {
        this.canShop = loginState.user.hasCapability(Capability.CAN_SHOP);
      }
      else {
        this.canShop = false;
      }
    });
  }

  ngOnInit() {
    this.assessmentGroupService.getAssessmentGroups().then((groups:AssessmentGroup[]) => {
      // add a display property so we can expand/contract it.
      this.groups = groups.map((g) => {
        let displayGroup = new AssessmentGroupDisplay();
        Object.assign(displayGroup, g);
        displayGroup.Show = false;
        return displayGroup;
      })
      return groups;
    })
    .then((groups) => {
      return this.assessmentTokenService.loadAssessmentTokens().then(() => {
        this.hasLoadedTokens = true;
      })
    });
  }
  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }

  public get tokensEnabled() {
    return this.assessmentTokenService.isTokensEnabled();
  }

  getTokensRemaining(assessment:Assessment) {
    if (!assessment) {
      return 0;
    }
    
    return this.assessmentTokenService.getRemainingTokens(assessment);
  }

  getGroupTokensRemaining(group:AssessmentGroupDisplay) {
    if (!group) {
      return 0;
    }
    
    return this.assessmentTokenService.getGroupRemainingTokens(group);
  }

  shouldBuyTokens(group:AssessmentGroupDisplay) {
    let tokens = this.getGroupTokensRemaining(group);
    return this.canShop && tokens <= 0;
  }

  pickGroup(group:AssessmentGroup) {
    this.selected.emit(group);
  }

  toggleGroup(group:AssessmentGroupDisplay, event:Event) {
    group.Show = !group.Show;
    console.log(group, group.Show);
    event.preventDefault();
    event.stopPropagation();
  }

  addAssessmentToGroup(group:AssessmentGroup, assessment:Assessment) {
    let dup = group.Assessments.find((a) => {return a.uid == assessment.uid });
    if (dup) {
      alert("This assessment already has been added.");
      return;
    }

    group.Assessments.push(assessment);
    this.assessmentGroupService.addAssessmentToGroup(group, assessment).then((assessment:Assessment) => {
      assessment.version = assessment.version;
      assessment.id = assessment.id;
    })
    .catch((error) => {
      console.error(error);
      // TODO: stephen need to display an error here...
      // remove it
      let index = group.Assessments.indexOf(assessment);
      if (index >= 0) {
        group.Assessments.splice(index, 1);
      }
    });
  }

  addGroup() {
    this.assessmentGroupService.createNewGroup(this.NewGroupName).then((group:AssessmentGroup) => {
      let display = new AssessmentGroupDisplay();
      Object.assign(display, group);

      // hide all the others, and show the one we just added.
      this.groups.forEach((g) => g.Show = false);
      display.Show = true;
      display.ShowAdd = true;
      this.NewGroupName = "";

      this.groups.push(display);
    });
  }

  triggerBuy(group:AssessmentGroup) {
    this.buy.emit(group);
  }

  public get Groups() {
    return this.groups;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/assessment-group-list/assessment-group-list.component.ts